import LaboratoryNav from "../../pages/Dashboard/Laboratory/LaboratoryNav";
import LaboratoryIndex from "../../pages/Dashboard/Laboratory/LaboratoryIndex";
import LaboratoryCategory from "../../pages/Dashboard/Laboratory/LaboratoryCategory/LaboratoryCategory";
import LaboratoryTypes from "../../pages/Dashboard/Laboratory/LaboratoryType/LaboratoryTypes";
import PatientTest from "../../pages/Dashboard/Laboratory/PatientTest/PatientTest";
import PatientTestFree from "../../pages/Dashboard/Laboratory/PatientTestFree/PatientTestFree";
import PatientTestResults from "../../pages/Dashboard/Laboratory/PatientTest/PatientTestResults";
import TestSample from "../../pages/Dashboard/Laboratory/TestSample/TestSample";
import PatientTestResultsFree from "../../pages/Dashboard/Laboratory/PatientTestFree/PatientTestResultsFree";

const laboratoryRoutes = {
  path: "/laboratory",
  element: <LaboratoryNav />,
  children: [
    { path: "/laboratory", element: <LaboratoryIndex /> },
    { path: "/laboratory/test-category", element: <LaboratoryCategory /> },
    { path: "/laboratory/test-types", element: <LaboratoryTypes /> },
    { path: "/laboratory/patient-test", element: <PatientTest /> },
    { path: "/laboratory/test-results/:id", element: <PatientTestResults /> },
    { path: "/laboratory/patient-test-free", element: <PatientTestFree /> },
    {
      path: "/laboratory/test-results-free/:id",
      element: <PatientTestResultsFree />,
    },
    { path: "/laboratory/test-sample", element: <TestSample /> },
  ],
};

export default laboratoryRoutes;
